module.exports = __webpack_public_path__ + "img/cash.8d27da68.png";